import axios from "axios";
import API_BASE_URL from "./config";
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  setLocalAccessToken,
  getLocalUser,
  logout,
} from "./helpers";

const fetch = (options) => {
  const { method = "get", data, url, responseType } = options;

  const authToken = getLocalAccessToken();
  authToken &&
    (axios.defaults.headers.common.Authorization = `Bearer ${authToken}`);

  switch (method.toLowerCase()) {
    case "get":
      return axios.get(url, {
        params: data,
        responseType,
      });
    case "delete":
      return axios.delete(url, {
        data,
      });
    case "post":
      switch (options.upload) {
        case true:
          return axios.post(url, options.formData, options.config);
        default:
          return axios.post(url, data);
      }
    case "put":
      switch (options.upload) {
        case true:
          return axios.put(url, options.formData, options.config);
        default:
          return axios.put(url, data);
      }
    case "patch":
      return axios.patch(url, data);
    case "download":
      return axios.get(url, {
        params: data,
        responseType,
      });
    default:
      return axios(options);
  }
};

export default function request(options) {
  return fetch(options)
    .then((response) => {
      const { data, status } = response;
      return {
        success: true,
        raw: data,
        statusCode: status,
      };
    })
    .catch((err) => {
      const { response } = err;
      let msg;
      let statusCode;
      const data = response?.data;
      if (response && response instanceof Object) {
        const { data, statusText } = response;
        statusCode = response.status;

        msg = data.error || statusText;
        if (statusCode === 401) {
          axios.defaults.headers.common.Authorization = "";
          const refreshToken = getLocalRefreshToken();
          const userDetails = getLocalUser();

          if (!userDetails?.id) {
            return {
              success: false,
              raw: data,
              statusCode,
              message: msg,
            };
          }
          const payload = {
            refreshToken,
          };

          return axios
            .post(`${API_BASE_URL}/auth/refresh-token`, payload)
            .then((resp) => {
              const refreshData = resp.data ? resp.data : {};
              setLocalAccessToken(refreshData.accessToken);
              axios.defaults.headers.common.Authorization = `Bearer ${refreshData.accessToken}`;
              return request(options);
            })
            .catch((error) => {
              const errResponse = error.response;
              const errStatus = errResponse.status;
              if (errStatus === 401 || errStatus === 404) {
                logout();
                return {
                  success: false,
                  statusCode: errStatus,
                  message: errResponse.message || "Token expired",
                  raw: data,
                };
              }
              return {
                success: false,
                statusCode: errStatus,
                message: errResponse.data
                  ? errResponse.data.message
                  : errResponse.statusText,
                raw: data,
              };
            });
        }
      } else {
        statusCode = 600;
        msg = "Poor internet connection.";
      }
      return { success: false, statusCode, message: msg, raw: data };
    });
}
